<div class="container">
    <div class="row">
        <div [class.col-xl-6]="!isPartialSuccessPage"
             [class.col-xl-7]="isPartialSuccessPage"
             class="error-content col-md-10 col-sm-12"
        >
            <c11n-icon [altText]="errorContent?.iconVariant === 'success' ? 'success' : 'error'"
                       [name]="errorContent.icon || 'error-fill'"
                       [ngClass]="errorContent?.iconVariant === 'success' ? 'custom-c11n-svg--fill-success' : 'custom-c11n-svg--fill-error'"
                       [scale]="'larger'"
                       class="custom-c11n-svg--size-large c11n-space-stack-3x"
                       custom-c11n></c11n-icon>

            <h1 class="c11n-text-2xl-headline c11n-space-stack-3x" data-cy="page-title">
                {{ errorContent.title }}
            </h1>

            <ng-container *ngIf="isPartialSuccessPage && (partialSuccessAccountNames$ | async) as accountNames">
                <ng-container *ngIf="partialSuccessAccessLevelLabel$ | async as accessLevelLabel">
                    <div class="review-container" data-cy="successful-submissions-container">
                        <p class="c11n-text-md-bold c11n-space-stack-2x">
                            <strong>{{ partialSuccessListLabel }}</strong>
                        </p>
                        <ul class="review-container__account-list" role="list">
                            <li
                                    *ngFor="let accountName of accountNames"
                                    class="account-item"
                                    data-cy="account-item"
                            >
                                {{ accountName }} ({{ accessLevelLabel }})
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </ng-container>

            <div
                    [class.col-xl-9]="isPartialSuccessPage"
                    [innerHTML]="errorContent.text"
                    [ngClass]="{
                    'error-text-container c11n-space-stack-6x': errorContent.primaryButton || errorContent.secondaryButton
                }"></div>

            <div *ngIf="errorContent.primaryButton || errorContent.secondaryButton" class="error-buttons-container">
                <c11n-button
                        (clickEvent)="onPrimaryButtonClick()"
                        *ngIf="errorContent.primaryButton"
                        [fullWidth]="isMobileView$ | async"
                        [labelText]="errorContent.primaryButton.label"></c11n-button>
                <c11n-button
                        (clickEvent)="onSecondaryButtonClick()"
                        *ngIf="errorContent.secondaryButton"
                        [fullWidth]="isMobileView$ | async"
                        [labelText]="errorContent.secondaryButton.label"
                        [variant]="'secondary'"></c11n-button>
            </div>
            <a
                    [href]=""
                    c11n-link
                    variant="primary-reinforced"
            >{{ errorContent.link }}</a>
        </div>
    </div>
</div>
